module.exports = __webpack_public_path__ + "img/main.391d38ce.svg";